import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlMutation } from 'src/graphql/client';

const MUTATION = gql`
  mutation SubmitSurvey(
    $requestId: ID!
    $respond: SurveyRespondTypeEnum!
    $answers: JSON
    $customerId: ID!
    $surveyVersion: Int!
  ) {
    submitSurvey(
      requestId: $requestId
      respond: $respond
      answers: $answers
      customerId: $customerId
      surveyVersion: $surveyVersion
    ) {
      status
      bonusWordsCredit
    }
  }
`;

export function submitSurvey(variables) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { ...variables, answers: JSON.stringify(variables.answers) },
  }).then(({ data }) => getSingleProp(data));
}
